import { store } from '@betacrew/jars-flux';
import { all, call, put,select, takeLatest } from 'redux-saga/effects';
import PayerDataService from '../../../../../services/PayerDataService';
import { TOASTER_VARIANT } from '../../../../components/toast/constants';
import { addNotifications } from '../../../toaster/ToasterPortalSlice'; 
import { PAGE_STATE } from '../../../constants/constants';
import { componentKey, setLoadingState, setPayersData, setTotalPayers, setGroupIDs, setGroupIdChecked } from './AssignPayersSlice';
import RightsManagementDataService from '../../../../../services/RightsManagementDataService';
import Payer from '../../../../../libs/utility/Payer';
import { selectPayer } from '../../manageusers/ManageUserSlice';
import { USER_LOADING_STATES } from '../../constant';
import General from '../../../../../libs/utility/General';

export const { managePayersForMember, getGroupIDs, getPayersList, getAssignedPayers, checkGroupIdChecked } = {
    getGroupIDs: (payload) => {
        return {
            type: "USERS/GET_GROUP_IDS",
            payload: payload
        }
    },
    getPayersList: (payload) => {
        return {
            type: "USERS/GET_PAYERS_LIST",
            payload: payload
        }
    },
    assignGroupIDs: (payload) => {
        return {
            type: "USERS/ASSIGN_GROUP_ID",
            payload: payload
        }
    },
    getAssignedPayers: (payload) => {
        return {
            type: "USERS/GET_ASSIGNED_PAYERS",
            payload: payload
        }
    },
    checkGroupIdChecked: (payload) => {
        return {
            type: "USERS/CHECK_GROUP_ID_CHECKED",
            payload: payload
        }
    },
    managePayersForMember: (payload) => {
        return {
            type: "USERS/MANAGE_PAYERS_FOR_MEMBERS",
            payload: payload
        }
    },
}

function* getGroupIDsAsync() {
    try {

        yield put(setLoadingState({ state: USER_LOADING_STATES.PAYER_GROUP_READY }));

        const response = yield RightsManagementDataService.getGroupIDs();

        if(response.data.Status === 0){
            yield put(addNotifications({
                heading: "Error",
                message: response.data.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else {
            yield put(setGroupIDs(response.data.Data))
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.PAYER_GROUP_READY }))
    }
}

function* getPayersListAsync(action) {
    try {
        yield put(setLoadingState({ state: USER_LOADING_STATES.PAYERS_LIST_LOADING }));
        const {filterText, skip, rowsPerPage, IdNumber, IsDesc} = action.payload;
        const params = {
            PageNumber: (skip / rowsPerPage) + 1 || 1,
            PageSize: rowsPerPage || 10,
            FilterText: filterText || "",
            IdNumber: IdNumber || "",
            IsDesc: IsDesc || false,
        }

        const response = yield PayerDataService.getPaginatedPayersList(params);
        if(response.data.Status === 0){
            yield put(addNotifications({
                heading: "Error",
                message: response.data.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else {
            yield put(setPayersData(General.extractDataFromResponseData(response.data)))
            const totalPayers = General.extractPaginationTotalFromResponse(response.data)
            yield put(setTotalPayers(totalPayers))
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.PAYERS_LIST_READY }))
    }
}

function* getAssignedPayersListAsync(action) {
    try {
        yield put(setLoadingState({ state: USER_LOADING_STATES.ASSIGN_PAYER_LOADING }));
        const { MemberId, PayerList } = action.payload;
        const params = {
            MemberId: MemberId || "",
        }

        const response = yield RightsManagementDataService.getAssignedPayersList(params);
        if(response.data.Status === 0){
            yield put(addNotifications({
                heading: "Error",
                message: response.data.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else {
            const payerIdList = PayerList.map(payer => payer.PayerDetailId)
            yield put(selectPayer(response.data.Data.filter(payer => payerIdList.includes(payer.PayerDetailId)).map(payer => ({...payer, isSelected: true}))))
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.ASSIGN_PAYER_READY }))
    }
}


function* checkGroupIdCheckedAsync(action) {

    try {
        yield put(setLoadingState({ state: USER_LOADING_STATES.PAYER_GROUP_FILTER_LOADING }))
        const response = yield RightsManagementDataService.checkIfGroupIdCheckedForMember(action.payload);
        if (response?.data.Status === 1) {
            yield put(setGroupIdChecked(response.data.Data))
        } else {
            yield put(addNotifications({ 
                heading: "Error updating Member", 
                message: response?.data?.Message 
            }));
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Error Fetching Member Roles", 
            message: error?.response?.data?.Message 
        }));
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.PAYER_GROUP_FILTER_READY }))
    }

}


function* managePayersForMemberAsync(action) {

    try {
        yield put(setLoadingState({ state: USER_LOADING_STATES.PAYER_GROUP_FILTER_LOADING }))
        const response = yield RightsManagementDataService.managePayersForMember(action.payload);

        if (response?.data.Status === 1) {
            yield put(addNotifications({ 
                heading: "Success", 
                message: response.data.Message,
                variant: TOASTER_VARIANT.SUCCESS
                
            }));
        } else {
            yield put(addNotifications({ 
                heading: "Error updating Member", 
                message: response?.data?.Message 
            }));
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Error Fetching Member Roles", 
            message: error?.response?.data?.Message 
        }));
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.PAYER_GROUP_FILTER_READY }))
    }

}

function* rootSaga() {
    yield all([
        takeLatest(getGroupIDs().type, getGroupIDsAsync),
        takeLatest(getPayersList().type, getPayersListAsync),
        takeLatest(getAssignedPayers().type, getAssignedPayersListAsync),
        takeLatest(checkGroupIdChecked().type, checkGroupIdCheckedAsync),
        takeLatest(managePayersForMember().type, managePayersForMemberAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);